import React, { useEffect } from "react";

type PrivateRouteProps = {
  Component: React.ComponentType;
};

function PrivateRoute({ Component }: PrivateRouteProps) {
  const loginState = localStorage.getItem("useLoggedAmplify");

  useEffect(() => {
    if (loginState !== "true") {
      // Keep existing window.location redirect for unauthorized users
      window.location.replace(`${window.location.origin}/login`);
    }
  }, [loginState]);

  if (loginState !== "true") {
    return null; // nothing to render while redirecting
  }

  return <Component />;
}

export default PrivateRoute;
